import React from 'react';
import { HAZARD_SVG } from './hazardIcon';
import { hazardMarkup } from './hazardMarkup';

/** Inline hazard glyph for legends, filters and popups (markup is repo-owned). */
const HazardGlyph = ({ type, size = 16 }) => {
  if (!Object.hasOwn(HAZARD_SVG, type)) return null;
  return (
    <span
      className="inline-flex shrink-0"
      style={{ width: size, height: size }}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: hazardMarkup(HAZARD_SVG[type], { size }) }}
    />
  );
};

export default HazardGlyph;
